// import router from '@/router'
import http from '@/apis'
import api from '@/apis/user'
import appApi from '@/apis/app'
import DictUtil from '@/utils/dict.js'

export default {
  loadDict (context) {
    if (context.state.dict && context.state.dict.length) {
      return Promise.resolve(context.state.dict)
    }
    return http.request(appApi.listDict, { group: DictUtil.getGroups() }).then(data => {
      context.commit('SET_DICTDATA', data)
    })
  },
  getDictData ({ commit }) {
    return http.request(appApi.getDictData).then(res => {
      commit({
        type: 'SET_DICTDATA',
        data: res.data
      })
      return res
    })
  },
  getTenant ({ commit }, tenantCode) {
    return http.request(api.getTenant, { tenantCode }).then(res => {
      if (res.status === 200 && res.data) {
        commit('SET_TENANT', res.data)
        return true
      } else {
        alert(`租户[${tenantCode}]未初始化，请联系管理员`)
      }
    })
  },
  /* 获取用户和陪审员信息 */
  getUserInfo ({ commit }) {
    return http.request(api.JurorInfoGet).then(res => {
      commit({
        type: 'SET_USERINFO',
        data: res.data
      })
      return res
    })
  },
  /* 获取陪审员头像 */
  getUserAvatar ({ commit }) {
    return new Promise((resolve, reject) => {
      // 查询陪审员头像
      http.request(api.getUserBase64Avatar).then(res => {
        if (res.status === 200 && res.data) {
          const avatar = 'data:image/png;base64,' + res.data
          commit({
            type: 'SET_USER_AVATAR',
            data: avatar
          })
        }
        resolve()
      }).catch(() => {
        resolve()
      })
    })
  },
  getRoles ({ commit }) {
    return http.request(api.getRoles)
      .then(res => {
        if (res.status === 200 && res.data) {
          commit({
            type: 'SET_ROLES',
            data: res.data
          })
          return res.data
        }
      })
  },
  getUserData ({ commit }) {
    return http.request(api.getJudgeInfo)
      .then(res => {
        if (res.status === 200 && res.data) {
          commit({
            type: 'SET_USER_DATA',
            data: res.data
          })
          return res.data
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js